<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import { buildOrganizationJsonLd, buildSeoMeta, buildWebSiteJsonLd, DEFAULT_SITE_DESCRIPTION } from '@/util/seo';

export default {
  metaInfo() {
    return buildSeoMeta({
      title: 'KFX Development',
      description: DEFAULT_SITE_DESCRIPTION,
      path: this.$route.path,
      jsonLd: [
        buildOrganizationJsonLd(),
        buildWebSiteJsonLd(),
      ],
    });
  },
  created() {
    this.$store.dispatch('getAppData');
  },
};
</script>

<style lang="scss">
@import './scss/variables';

* {
  box-sizing: border-box;
}

.site-layout :focus,
.project-layout :focus {
  outline: var(--theme-accent) 1px solid;
}

input:focus {
  outline-offset: unset;
}

::-webkit-scrollbar {
  width: .5rem;

  &-track {
    background: rgb(10, 10, 24);
    border-left: 1px solid rgba(255,255,255,.1);
  }

  &-thumb {
    background: rgba(255, 255, 255, .4);
  }
}

html {
  height: 100%;
  font-size: 12px;
  scrollbar-color: hsla(0, 0%, 100%, .4) rgba(0, 0, 0, 0%);

  @include breakpoint($md) {
    font-size: 14px;
  }

  @include breakpoint($lg) {
    font-size: 16px;
  }
}

body {
  margin: 0;
  height: 100vh;
  display: flex;
  overflow-x: hidden;
}

#app {
  font-family: 'Source Sans Pro', 'Open Sans', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #FFF;
  line-height: 1.5;
  background-color: #141422;
  width: 100%;
  height: 100%;
  display: flex;
  flex-flow: column;
}

.vdp-datepicker {
  .vdp-datepicker__calendar {
    background: $grey;
    border: 0;
    box-shadow: 0 0 1em rgba(0,0,0,.2);

    header span {
      &.prev:after {
        border-right-color: white;
      }

      &.next:after {
        border-left-color: white;
      }

      &:not(.disabled):hover {
        background: rgba(255,255,255,.2);
      }
    }

    .cell {
      &:not(.blank):not(.day-header):not(.disabled):hover {
        border-color: var(--theme-accent);
      }

      &.selected {
        background: var(--theme-accent);
      }
    }

    .disabled {
      opacity: .3;
    }
  }
}

</style>
